import { render, staticRenderFns } from "./CorrelationPlot.vue?vue&type=template&id=07dbc4b7&scoped=true"
import script from "./CorrelationPlot.vue?vue&type=script&lang=js"
export * from "./CorrelationPlot.vue?vue&type=script&lang=js"
import style0 from "./CorrelationPlot.vue?vue&type=style&index=0&id=07dbc4b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dbc4b7",
  null
  
)

export default component.exports